export const API_GET_ALL_PAYMENTS='/pago/contratados/';
export const API_GET_CONTRACTED_BY_COMPANY='/pago/obtener/contratados/';
export const API_POST_AUTOMATIC_REGISTER='/pago/registro/automatico';
export const API_POST_REVIEW_PAYMENT='/pago/revision';
export const API_GET_MODULES='/admin/modulos';
export const API_GET_COMPANIES='/admin/empresas/obtener/';
